

import React, { memo, useCallback, useContext, useMemo } from 'react';
import cx from 'classnames';
import DataTableCell from '../DataTableCell';

import { getDataTableCellValue } from '../../utils/factories/dataTableCellValueFactory';
import {
  getDataTableBodyCellStyleModifiers,
  getDataTableBodyCellTreeStyles, hasDataTableBodyCellExpander } from
'../../utils/factories/dataTableCellStyleFactory';

import { DataTableContext } from '../../context/dataTableContext';
import { DATA_TABLE_TREE_EXPANDER_ICON_SIZE } from '../../../../../common/constants/dataTableStyleVariables';
import ExpanderIcon from '../../../ExpanderIcon';
import { hasDataTableTreeRowNodeChildren } from '../../utils/dataTableRow';
import '../../styles/_data-table-body-cell.scss';










const DataTableBodyCell = (props) => {
  const {
    column,
    treeRowNode,
    colSpan,
    isTree = false,
    isExpanded
  } = props;

  const {
    hasTreeData,
    treeStyleType,
    styleType,
    onRowExpandChange
  } = useContext(DataTableContext);

  const { data: row } = treeRowNode;

  const value = useMemo(() => getDataTableCellValue(
    row, column, treeRowNode
  ), [row, column, treeRowNode]);
  const styleModifiers = useMemo(() => getDataTableBodyCellStyleModifiers(
    row, column
  ), [row, column]);

  const expanderStyles = getDataTableBodyCellTreeStyles(treeRowNode, treeStyleType);
  const hasExpander = hasDataTableBodyCellExpander(isTree, hasTreeData);
  const hasChildren = hasDataTableTreeRowNodeChildren(treeRowNode);

  const onExpanderIconClick = useCallback(
    (e) => {
      onRowExpandChange(treeRowNode.id);
      if (e && e.stopPropagation) e.stopPropagation();
    }, [row, onRowExpandChange]
  );

  return (
    <DataTableCell
      className={cx(
        'data-table-body-cell', {
          [`data-table-body-cell--${styleType}`]: styleType,
          [`data-table-body-cell--tree-${treeStyleType}`]: isTree
        }
      )}
      column={column}
      colSpan={colSpan}
      {...styleModifiers}>

      {hasExpander &&
      <div
        className="data-table-body-cell__expander"
        style={expanderStyles}>

          {hasChildren &&
        <ExpanderIcon
          size={DATA_TABLE_TREE_EXPANDER_ICON_SIZE}
          isExpanded={Boolean(isExpanded)}
          onClick={onExpanderIconClick} />}


        </div>}


      {value}
    </DataTableCell>);

};

export default memo(DataTableBodyCell);